//#region Imports
import React, { useEffect, useState } from "react";
import { SafeAreaView, StyleSheet, FlatList } from "react-native";
import { useTheme } from "@react-navigation/native";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { useAssessment } from "../../../hooks/useAssessment";
import { useAccountContext } from "../../../hooks/useAccountContext";
import CustomAssessment from "../../../components/AssessmentBuilderCmponent/Assessment/CustomAssessment";
//#endregion

const ResponseScreen = (props) => {
  //#region Function Definitions
  const { user, clientApi, username } = useAuthContext();
  const { account } = useAccountContext();
  const { loadAssessment, isLoading } = useAssessment();
  const { colors } = useTheme();
  // TODO Change organization id when you want to support multiCple companies
  // * state array of section each section contains array of questions
  const { assmData } = props;
  const [tccObjects, setTccObjects] = useState([])
  const [userAssmData, setUserAssmData] = useState(undefined);
  const [assm, setAssm] = useState([]);
  const [asmmUI, setAssmUI] = useState('')
  const [stageTitles, setStageTitles] = useState([]);
  const [toView, setToView] = useState(0);
  const styles = makeStyles(colors, assm.length > 1 ? true : false);
  //#endregion

  //#region Loading
  const loadAssmDetails = () => {
    loadAssessment(
      clientApi,
      user.token,
      username,
      account.employeeId,
      assmData.assmEmplUi,
      assmData.cType,
      assmData.type
    ).then((userData) => {
      setUserAssmData(userData);
      copyDetails(userData);
    });
  };

  const copyDetails = (userData) => {
    if (userData === undefined)
      return
    setAssmUI(assmData.assmEmplUi)
    const newAssmArray = userData?.map((assmData) => ({
      assm_emplUI: assmData.assmEmplUi,
      id: assmData.assmUi,
      assm_group_id: "",
      organization_id: "8F844600-801E-41C7-ABF0-27F80CDFB625",
      assm_title: assmData.description,
      assm_instructions: assmData.instructions,
      assm_from_date: assmData.assmFromDate,
      assm_to_date: assmData.assmToDate,
      assm_allowChangeOfAppraiser: assmData.allowChangeOfAppraiser,
      assm_type: assmData.assmType,
      assm_company: assmData.assmCompany,
      assm_submitted: assmData.submitted === "SUBMITTED" ? true : false,
      require_login: true,
      sectionQuestionList: assmData.assmSect.map((Section) => ({
        id: Section.sectionUi,
        assm_header_id: Section.assmUi,
        section_name: Section.description,
        section_instructions: Section.instructions,
        section_url_img: Section.section_url_img,
        isSectionCover: Section.isSectionCover,
        graphAxis: Section.graphAxis,
        useOnGraph: Section.useOnGraph,
        section_quantitative: Section.isQuantitative,
        section_showResults: Section.isResult,
        section_hideComparison: Section.hideMeetingComparison,
        section_rotw: "",
        section_weight: Section.weight,
        section_order: Section.sectionId,
        section_questions: Section.assmQuest.map((Question) => ({
          id: Question.questUI,
          parent_id: Question.sectionUI,
          quest_id: Question.questId,
          question_name: Question.description,
          question_weight: Question.weight,
          quest_instructions: Question.instructions,
          quest_sums: Question.sums,
          quest_value: Question.value,
          quest_isResult: Question.isResult,
          quest_isRequired: Question.isRequired,
          questImgUrl: Question.section_url_img,
          isQuestionCover: Question.isQuestionCover,
          quest_controls: Question.controls,
          question_lines: Question.assmQuestLine.map((QuestionLine) => ({
            id: QuestionLine.questLineUI,
            question_id: QuestionLine.lineId,
            question_line_description: QuestionLine.description,
            question_line_questUI: QuestionLine.questUI,
            question_line_valuelist: QuestionLine.valuelist,
            question_line_order: QuestionLine.lineId,
            question_line_instructions: QuestionLine.instructions,
            question_line_control: QuestionLine.control,
            question_line_assm_quest_line_type_id:
              QuestionLine.assmQuestLineTypeId,
            question_line_resp: QuestionLine.response,
            question_line_respUI: QuestionLine.respUI,
            has_assmresp: 1,
          })),
        })),
      })),
    }));
    // * Create a table of Question Lines for questions with controls as  TableCustomControls
    // *  { questionId, array of original lines}
    // * Always 1 assessment in table except when WFL7 view appraisee assessment. 
    const newTccObjects = [];

    newAssmArray.forEach((assmItr) => {
      if (!assmItr.assm_submitted) {
        assmItr.sectionQuestionList.forEach((sectionItr) => {
          sectionItr.section_questions.forEach((questItr) => {
            if (questItr.quest_controls === "TableCustomControls") {
              newTccObjects.push({ questUI: questItr.id, tccArr: questItr.question_lines });
            }
          });
        });
      }
    });
    setTccObjects(prevTccObjects => [...prevTccObjects, ...newTccObjects]);
    
    
    setAssm(newAssmArray);
    setToView(1);
  };

  useEffect(() => {
    loadAssmDetails();

    // * Set up titles for the responses preview 
    // * while completing stages with preview responses.
    let tempTitles = [];
    for (let i = 0; i < props.assessmentToLoad.progress; i++) {
      switch (i) {
        case 0:
          tempTitles.push('Appraisee Responses Preview')
          break;
        case 1:
          tempTitles.push('Appraiser Responses Preview')
          break;
        case 2:
          tempTitles.push('Meeting Stage Preview')
          break;
        case 3:
          tempTitles.push('Acceptance Stage Preview')
          break;
        default:
          break;
      }
    }
    setStageTitles(tempTitles)

  }, []);
  //#endregion

  // TODO Add Margin on the stageTitles CustomLabel 
  return (
    assm !== undefined && (
      <SafeAreaView style={[styles.main]}>
        {assm && <CustomAssessment
          isLoading={isLoading}
          company={assm.assm_company}
          allAssm={assm}
          assmUI = {asmmUI}
          assm={assm[assm?.length - 1]}
          index={assm?.length - 1}
          setAssm={setAssm}
          sectionQuestionList={assm[assm?.length - 1]?.sectionQuestionList}
          sectionQuestionListStage1={assm.length === 1 ? undefined : assm[0]?.sectionQuestionList}
          sectionQuestionListStage2={assm.length === 2 ? undefined : assm[1]?.sectionQuestionList}
          sectionQuestionListStage3={assm.length === 3 ? undefined : assm[2]?.sectionQuestionList}
          setShowResponseScreen={props.setShowResponseScreen}
          setShowCreateScreen={props.setShowCreateScreen}
          setShowCreateGroup={props.setShowCreateGroup}
          setShowAssessmentsAdmin={props.setShowAssessmentsAdmin}
          setShowMyAssessments={props.setShowMyAssessments}
          toView={toView}
          response_yn={props.response}
          currentStage={assm?.length}
          Stages={assm.length}
          tccObjects={tccObjects}
          isPreview={0}
        />}
      </SafeAreaView>
    )
  );
};

const makeStyles = (colors, isOnlyOne = true) =>
  StyleSheet.create({
    main: {
      flex: 1,
      margin: 10,
      flexDirection: isOnlyOne ? 'row' : 'column',
    },

  });

export default ResponseScreen;
